import { market } from "../market/tr";
import { invite } from "../invite/tr";
import { property } from "../property/tr";
import { advertise } from "../advertise/tr";
import { login, download } from "../login/tr";
import { trading } from "../trading1/tr";
import { contest } from "../contest/tr";
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/tr";
import { games } from "../games/tr";
import { taskCenter } from "../task/tr";
import { ieo } from "../ieo/tr";
import { earn } from "../earn/tr";
import { tradingContest } from "../tradingContest/tr";
import { agent } from "../agent/tr";
import { live } from "../live/tr";
import { hongbao } from "../hongbao/tr";


const time = {
    r: "Gün",
    s: "Saat",
    f: "Dakika",
    m: "Saniye",
};
// 状态
const state = {
    preheatIng: "Isınma sürüyor",
    purchaseIng: "Yakalama sürüyor",
    over: "Bitti",
    finish: "Tamamlandı",
    noData: "Henüz veri yok",
    process: "Destek sürüyor",
    sellout: "Tükendi",
};
// 模板文字
const text = {
    now: "Devam ediyor",
    start: "Bu turun başlamasına kalan süre",
    end: "Bu turun bitmesine kalan süre",
    jd: "Bu turun ilerlemesi",
    complete: "Tamamlandı",
    limited: "Sınırlı zaman indirim fiyatı",

    finish: "Tamamlandı",
    subscribing: "Abonelik sürüyor",
    subscribeNow: "Hemen abone ol",
    buyStart: "Aboneliğin başlamasına kalan süre",
    buyEnd: "Aboneliğin bitmesine kalan süre",
    projectAmount: "Proje pay sayısı",
    quota: "Hisse başına kota",
    buyPrice: "Abonelik fiyatı",
    buyLimit: "Abonelik limiti",
    buyAmount: "Abonelik miktarı",
    buyPos: "Abonelik para birimi pozisyonu",
    startDate: "Başlangıç zamanı",
    endDate: "Bitiş zamanı",
    projectSuppot: "Proje desteği",
    websit: "Proje web sitesi",
    projectDetail: "Proje detayları",
    cycle: "Abonelik döngüsü",
    all: "Tümü",
    step1: "Isınma",
    step2: "Abonelik",
    step3: "Çekiliş",
    step4: "Sonuçların açıklanması",
    subOrder: "Abonelik siparişi",
    myOrder: "Kazanan siparişlerim",
    proCoin: "Proje para birimi",
    buyCoin: "Abonelik para birimi",
    orderDate: "Sipariş zamanı",
    issuanceQuota: "Dağıtım kotası",
    dealAmount: "Tamamlanan miktar",
    dealPrice: "Tamamlanan tutar",
    status: "Durum",
    ctrl: "İşlem",
    checkOrder: "Talep numarasını görüntüle",
    subNum: "Abonelik talep numarası",
    myNum: "Kazanan talep numarası",
    status0: "Abone olundu",
    status1: "Ödeme bekleniyor",
    status2: "Tamamlandı",
    conditionTerm1: "Abonelik başlangıç zamanından * gün önce,",
    conditionTerm2: "İşlem çifti *",
    conditionTerm3: "Tüm işlem çiftleri",
    conditionTerm4: "Parite işlemlerindeki toplam işlem tutarı (USDT) kümülatif değeri her *'a ulaştığında 1 pay abone olunabilir",
    noData: "Henüz veri yok",
    qgsc: "Satın alma kilitleme",
    yhsg: "Çekilişle abonelik",
    sgsb: "Abonelik başarısız",

    supply: "Bu tur kotası",
    rate: "Dönüşüm oranı",
    ceiling: "Destek üst sınırı",
    xmwc: "Proje tamamlandı",
    xmze: "Proje toplam tutarı",
    zkjj: "İndirimli ortalama fiyat",
    cyrs: "Katılımcı sayısı",
    round: "[*]. Tur",
    r: "kişi",
    cgqg: "Başarıyla satın alındı",
    cgzl: "Başarıyla desteklendi",
    xmed: "Proje kotası",
    kszl: "Destek başlangıç zamanı",
    ksqg: "Satın alma başlangıç zamanı",
    jsqg: "Satın alma bitiş zamanı",
    jszl: "Destek bitiş zamanı",
    hdgz: "Etkinlik kuralları",
    xmjs: "Proje tanıtımı",
    tcqr: "Ödemeyi onaylamadan çıkarsanız, bu satın alma etkinliği fırsatını kaybedebilirsiniz. Lütfen dikkatli hareket edin!",
    jxtc: "Çıkmaya devam et",
    fhzf: "Ödemeye dön",
    qgrsd: "Mevcut satın alma işlemi yoğun, lütfen sabırla bekleyin!",
    zltcqr: "Ödemeyi onaylamadan çıkarsanız, bu destek etkinliği fırsatını kaybedebilirsiniz. Lütfen dikkatli hareket edin!",
    zlqgrsd: "Mevcut destek işlemi yoğun, lütfen sabırla bekleyin!",
    wxts: "Hatırlatma: Lütfen ödemeyi en kısa sürede onaylayın, [*] dakika içinde ödeme tamamlanmazsa zaman aşımına uğrar ve pencere kapanır.",
};

const seckill = {
    sgno: "Abonelik koşullarını karşılamıyorsunuz",
    srjymm: "Lütfen işlem şifrenizi girin",
    ljzf: "Hemen öde",
};
const apply = {
    condition: "Abonelik koşulları",
    apply: "Hemen abone ol",
    buyPrice: "Abonelik fiyatı",
    buyAmount: "Abonelik miktarı",
    applyAmount: "Abonelik tutarı",
    forget: "İşlem şifresini mi unuttunuz?",
    noAmount: "Lütfen abonelik miktarını girin",
    buyLimit: "Abonelik limiti",
    success: "Abonelik başarılı!",
    paySummary: "Hatırlatma: Lütfen ödemeyi en kısa sürede onaylayın, <b>3 dakika içinde</b> ödeme tamamlanmazsa zaman aşımına uğrar ve pencere kapanır",
    appFull: "Abonelik miktarı çok büyük",
    seckill_async_fail_13: "İki abonelik arasındaki zaman aralığı {} dakika",
};

const seckillRes = {
    seckill_async_3: "Ödeme sürüyor, lütfen bekleyin!",
    seckill_async_5: "İptal başarılı",
    seckill_async_fail_1: "Üzgünüz! Lütfen sayfayı yenileyin ve tekrar deneyin!",
    seckill_async_fail_2: "Üzgünüz! Lütfen sayfayı yenileyin ve tekrar deneyin!",
    seckill_async_fail_3: "Üzgünüz! Lütfen sayfayı yenileyin ve tekrar deneyin!",
    seckill_async_fail_4: "Üzgünüz! Kota tükendi!",
    seckill_async_fail_5: "Üzgünüz! Ödeme zaman aşımına uğradı, lütfen tekrar deneyin!",
    seckill_async_fail_6: "Ödeme şifresi yanlış, lütfen tekrar girin!",
    seckill_async_fail_7: "İşlem şifresi hata sayısı sınırı aşıldı, lütfen daha sonra tekrar deneyin!",
    seckill_async_fail_8: "Üzgünüz! Ödeme zaman aşımına uğradı, lütfen tekrar deneyin!",
    seckill_async_fail_9: "Üzgünüz! Kota tükendi, bir sonraki sefere başarılar dileriz!",
    seckill_async_fail_10: "Mevcut satın alma işlemi yoğun, lütfen daha sonra tekrar deneyin!",
    seckill_async_fail_11: "Davranış doğrulaması başarısız!",
};
const header = {
    zcgl: "Varlık yönetimi",
    zczh: "Varlık hesapları",
    bbzh: "Parite hesabı",
    fbzh: "Para satın alma hesabı",
    bdbzh: "Kredi sigortası hesabı",
    wdgl: "Emir yönetimi",
    lswt: "Geçmiş emirler",
    qbhz: "Cüzdan transferi",
    yhzx: "Kullanıcı merkezi",
    wdhb: "Kırmızı zarfım",
    openOrder: "Mevcut emirler",
    dealStats: "Tamamlanan istatistikler",
    totalAsset: "Toplam varlık değerlemesi",
    cz: "Kontrat hesabı",
    gmcnyt: "CNYT satın al",
    yqfy: "Davet komisyonu",
    hbthhr: "HBT partneri",
    tczh: "Hesaptan çıkış",
    moreNew: "Daha fazla duyuru",
    gfgg: "Resmi duyurular",
    zxxw: "En son haberler",
    ckgd: "Daha fazla görüntüle",
    bbdd: "Parite siparişleri",
    bbwhydd: "Para birimi teminatlı süresiz kontrat siparişleri",
    etfdd: "ETF siparişleri",
    fbdd: "Fiat para siparişleri",
};

const recommend = {
    vol24h: "24H hacim",
    jyd: "İşlem çifti",
    jydlx: "İşlem çifti türü",
    zxj: "Son fiyat",
    change24: "24H değişim",
    line24: "Fiyat eğilimi (3 gün)",
};

const hyy = {
    bkt: "Açma",
    wqdkt: "Açmayı onaylıyorum",
    kt12: "1. Katılmadan önce dijital para kontrat işlemlerinin temel bilgilerini ve ilgili riskleri ayrıntılı bir şekilde anlamalısınız.",
    kt13: "2. Bu risk bildiriminde belirtilen riskler sadece örnek niteliğindedir ve dijital varlık türev işlemleriyle ilgili tüm risk faktörlerini kapsamamaktadır.",
    kt14: "3. Yatırımcıların risk toleransı ve kişisel durumlarına dayanarak bu kontrat işlemlerine katılıp katılmama konusunda dikkatli karar vermelerini ve dijital varlıklarını makul bir şekilde yapılandırmalarını öneriyoruz.",
    kt0: "Sayın kullanıcı:",
    kt1: "Kontrat hesabınız ve kontrat işlem izniniz henüz aktif değil, lütfen aşağıdaki içerikleri dikkatlice okuduktan sonra açmaya karar verin:",
    kt2: "1. Kontrat piyasasında işlem yaparken, piyasa fiyatı sizin aleyhinize hareket ederse ve pozisyon teminatınız yetersiz kalırsa, BiKing süresiz kontratları sistem kurallarına göre pozisyonunuzu tasfiye edecektir.",
    kt3: "2. BiKing süresiz kontratlarının iş kurallarını okumalı ve kabul etmelisiniz.",
    kt4: "4. BiKing süresiz kontratları kontrat işlem sistemine bağlıdır. Kullanıcı pozisyonlarının kâr/zararı kontrat piyasasındaki dalgalanmalara bağlı olarak değişir.",
    kt5: "5. Lütfen platformun ilgili kurallarına ve ilgili ülke/bölge yasalarına uyun.",
    kt6: "6. Dijital varlık türev işlemleri belirli yargı bölgelerinde politika düzenleme riskleriyle karşılaşabilir.",
    kt7: "7. Platform tarafından kontrol edilemeyen nedenlerden dolayı emirleriniz tam veya kısmen yerine getirilemeyebilir.",
    kt8: "8. 'Hedge' işlemleri de spekülatif işlemler gibi fiyat dalgalanması riski taşır.",
    kta9: "9. Kimlik doğrulaması yapmadıysanız veya Google Doğrulamayı bağlamadıysanız veya hesabınızı başkasına verdiyseniz, kontrat teminatınızın güvenliği etkilenebilir.",
    kta10: "3. Bazı aşırı piyasa koşullarında, açık pozisyonlarınızı kapatmak zor veya imkansız olabilir.",
    kt9: "Dikkatle okudum ve riski kabul ediyorum",
    kt10: "Kontrat hesabı ve kontrat işlem izni aç",
    zjhz: "Fon transferi",
    ljhz: "Hemen transfer et",
    qx: "Transferi iptal et",
    khz: "Transfer edilebilir",
    qxz: "Lütfen seçin",
    bz: "Para birimi",
    c: "Kaynak",
    zz: "Hedef",
    sl: "Miktar",
    qb: "Tümü",
    ktcg: "Açma başarılı",
    ktsb: "Açma başarısız",
    hzcg: "Transfer başarılı",
    hzsb: "Transfer başarısız",
    wyyd: "", //未勾选已经阅读提示文案
    tc: "Çıkış",
    warning1: "Lütfen para birimi seçin",
    warning2: "Transfer kaynağı boş olamaz",
    warning3: "Transfer hedefi boş olamaz",
    warning4: "Lütfen transfer edilebilir miktarı aşmayan bir sayı girin",
    warning5: "En fazla 4 ondalık basamak",
    gb: "Kapat",
    openSuccess: "Kontrat işlemini açtınız",
    openSuccessTip: "Lütfen kontrat hesabına fon transferi yapın",
    wsmyz: "Kimlik doğrulamanız tamamlanmadı",
    hdnm: "Kimlik doğrulamasını tamamlayın ve net [*] USDT transferi başına [**] USDT çamur kodu kazanın",
    nmjl: "Çamur kodu kaydı",
    nmhzjl: "Çamur kodu kazanma kaydı",
    gxn: "Tebrikler!",
    qwjy: "İşleme git",
    yfrndhyzh: "Kontrat hesabınıza yatırıldı",
    nzxy: "Kontrat hesabınıza [*] USDT daha transfer ederek [**] USDT çamur kodu alabilirsiniz",
    nmssm: "Çamur kodu nedir",
    nm: "Çamur kodu",
    nxhyzh: "Kontrat hesabınıza",
    text1: "Net [*] USDT üzeri kontrat hesabına transfer başına,",
    text2: "Kontrat hesabınıza [*] USDT daha transfer etmeniz yeterli",
    text3: "[*] USDT çamur kodu alabilirsiniz",
    text4: "Bakiye",
    text5: "Kontrat hesabınıza net [*] USDT üzeri transfer ettiniz, aldınız",
    not_get_nm: "Üzgünüz, çamur kodu kampanyası sona erdi, bu transferde çamur kodu alınamadı",
    yijie: "1. Birinci seviye",
    erjie: "2. İkinci seviye",
    ljjhr: "Net transfer",
    khd: "Kazanılabilir",
    hysnm: "Kontrat çamur kodu",
    bbgg: "Süresiz kontratlar 100x kaldıraç",
    hdsj: "Etkinlik zamanı:",
    hdxq: "Etkinlik detayları",
    ljhd: "Hemen talep et",
    xdxd: "Önce gelen alır",
    ylnnz: "Kazanırsan sen alırsın, kaybedersen ben öderim",
};

const Verification = {
    channel: "Resmi doğrulama kanalı",
    verify: "Lütfen doğrulanacak bilgileri girin",
    notes: "Güvenlik hatırlatması",
    notes1: "1. BiKing ile ilgili tüm e-postalar, WeChat hesapları, QQ numaraları, alan adları ve medya hesapları burada doğrulanabilir.",
    notes2: "2. Sosyal medya hesapları (Weibo, Twitter vb.) sadece isim sorgulamasını destekler, büyük/küçük harfe duyarlıdır.",
    notes3: "3. Doğrulama sonuçları hakkında sorularınız varsa, resmi web sitesinde veya uygulama içinde resmi müşteri hizmetleriyle iletişime geçebilirsiniz.",
    error: "Doğrulama başarısız",
    error1: "Sorguladığınız bilgi",
    error2: "resmi olarak onaylanmış bir kanal değil, lütfen varlık güvenliğini koruyun ve kişisel bilgi sızıntısına dikkat edin.",
    errorNote: "Dikkat edilmesi gerekenler",
    errorNote1: "1. Şu anda resmi doğrulama kanalları sadece e-posta, resmi WeChat hesapları, QQ numaraları, alan adları ve sosyal medya hesaplarını doğrulamayı desteklemektedir ",
    errorNote2: "2. WeChat gibi sohbet araçları sadece hesap numarasını (kullanıcı adı değil) destekler ",
    errorNote3: "3. Sosyal medya hesapları sadece isim sorgulamasını destekler, büyük/küçük harfe duyarlıdır",
    success: "Doğrulama başarılı",
    success1: "Sorguladığınız bilgi:",
    success2: "BiKing resmi onaylı",
    success3: "dır, bu numara/hesap başka kanallarda görünürse güvenilmez, lütfen varlık güvenliğine dikkat edin.",
    more: "Daha fazla görüntüle",
    know: "Anladım",
    weChat: "WeChat",
    name: "Alan adı",
    webo: "Weibo",
    twitter: "Twitter",
    email: "E-posta",
    contact: "Müşteri hizmetlerine başvur",
    bannerTip: "Sahtekarların BiKing adını kullanmasını önlemek için, iletişime geçen telefon, WeChat vb. bilgilerin BiKing resmi kanalı olup olmadığını bu sayfa aracılığıyla doğrulayabilirsiniz.",
};
const index = {
    downloadIos: "AppStore'dan indir",
    downloadAndroid: "Android indirme",
    downloadGoogle: "Google Play'den indir"
};

const indexPage = {
    gfgg: "Resmi duyurular",
    zxxw: "Son haberler",
    ckgd: "Daha fazla görüntüle",
};

const NAVS = {
    ty: "Avrupa Şampiyonası",
    hqsj: "Piyasa",
    game: "Oyun",
    fx: "Keşfet",
    sj: "Veri",
    fb: "Para satın al",
    bb: "Spot işlem",
    jr: "Finans",
    jyds: "İşlem turnuvası",
    hbhd: "Etkinlik Kırmızı Zarfı",
    gg: "Kaldıraçlı işlem",
    yxhy: "Süresiz kontrat",
    eft: "ETF işlemi",
    flhd: "Yarar etkinlikleri",
    flzx: "Yarar merkezi",
    fast: "Hızlı işlem",
    spec: "Profesyonel işlem",
    login: "Giriş yap",
    rig: "Kayıt ol",
    downapp: "BiKing Uygulamasını İndir",
    downappsum: "Akıcı deneyim, saniyeler içinde para yatırma/çekme",
    zichan: "Varlık",
    order: "Sipariş",
    qbhz: "Cüzdan transferi",
    lang: "Dil",
    calc: "Değerlendirme yöntemi",

    mb: "Para satın al",
    hq: "Piyasa",
    hy: "Kontrat",
    jy: "İşlem",
    lc: "Para kazan",
    fs: "Fansup",
    xy: "Akademi",
    byxy: "BiKing Akademi",
    byyx: "BiKing Araştırma Seçimi",
    coins: "COINS puanları",
    gd: "Daha fazla",
    yqhy: "Arkadaş davet et",
    rwzx: "Görev merkezi",
    bbms: "USDT ile Bitcoin gibi dijital varlıklar satın alın",
    ggms: "Platform dijital varlıkları ödünç verir, kâr ve riski büyütür",
    yxms: "100x kaldıraç desteği, kullanımı kolay ve çeşitli",
    etfms: "Kârı büyütün, tasfiye riski yok",
    pool: "Havuz paylaşımı",
    czzn: "Operasyon kılavuzu",
    gywm: "Hakkımızda",
    zhxx: "Hesap bilgisi",
    gd: "Kopya kontrat",
    yxhy: "Süresiz kontrat",
    zjhy: "Hediye kontrat",
    product: "Ürün",
};

const FOOTERS = {
    zxkf: "Çevrimiçi destek",
    fawu: "Yasal tavsiye",

    us: "Biz",
    product: "Ürün",
    service: "Hizmet",
    college: "Öğrenme",

    aboutUs: "Hakkımızda",
    rateSum: "Ücret açıklaması",
    notices: "Duyuru merkezi",
    helps: "Yardım merkezi",
    verific: "Resmi doğrulama kanalı",
    contact: "Bize ulaşın",

    fabi: "Para satın al",
    bibi: "Parite işlemi",
    ganggan: "Kaldıraçlı işlem",
    swiper: "Süresiz kontrat",
    etf: "ETF işlemi",
    licai: "Para kazan",

    apis: "API desteği",
    apisNew: "API desteği",
    addCoin: "Para listeleme başvurusu",
    vips: "VIP ayrıcalıkları",
    downapp: "Uygulama indirme",
    files: "Yasal belgeler",

    newuser: "BiKing Yeni Başlayan Kampı",
    swiperSchool: "Kontrat Akademisi",
    assistant: "Öğrenme asistanı",
    digitalintroduction: "Dijital varlık tanıtımı",

    watchword: "Dünya standartlarında yeşil işlem platformu",
    meiyitian: "Her gün, servet yaratın",
    chat: "Sohbet odası",
    shequncn: "Telegram Çince topluluğu",
    shequnen: "Telegram İngilizce topluluğu",
    shequnkr: "Telegram Korece topluluğu",
};

const SIDEBAR = {
    newuser: "Yeni başlayan",
    guide: "Rehber",
    bbsq: "Parite topluluğu",
    hysq: "Kontrat topluluğu",
    gd: "Sabit",
    sq: "Daralt",
};

const banner = {
    wzwh: "BiKing web sitesini kullanarak ve/veya hesabınızı koruyarak, güncellenmiş",
    sytk: "Kullanım Şartları",
    yszc: "Gizlilik Politikası",
    hh: "ve",
    cookie: "Çerez Politikasını",
    djgb: "kabul ettiğinizi onaylıyorsunuz. X'e tıklayarak yukarıdaki şartları ve politikaları okuduğunuzu ve kabul ettiğinizi teyit edersiniz.",

    title: "Çeşitlendirilmiş oyun ve dijital para işlem platformu",
    marketTitle: "Dijital para işleminde uzmanız",
    marketSubTitle: "Kullanıcılara daha güvenli ve istikrarlı kripto varlık türev işlem hizmeti sunmaya çalışıyoruz",
    pathTitle: "Dijital para yolculuğunuzda güçlü yardımcınız",
    pathSubTitle: "Milyonlarca kullanıcının seçimi, güvenebileceğiniz platform",
    jylz: "300 milyar dolar",
    jyl: "72 saat işlem hacmi",
    sxs: "Listelenen kripto para",
    zcyh: "Kayıtlı kullanıcı",
    zdjy: "En düşük işlem ücreti",
    connectTitle: "Neden bizi seçmelisiniz",
    connectSubTitle: "BiKing servet yaratmanıza, büyütmenize ve korumanıza yardımcı olur",
    advantageText1: "Üst düzey performans · anlık işlem",
    advantageSubText1: "Londra Borsası teknolojisi, ultra düşük gecikme, anlık eşleştirme",
    advantageText2: "Varlık güvencesi · maksimum güvenlik",
    advantageSubText2: "BiKing CCSS standartlarına uyar, varlık ve veri güvenliğini sağlar",
    advantageText3: "Yüksek likidite · düşük spread",
    advantageSubText3: "BiKing kontrat kaldıraç işlemi, ultra verimlilik, minimum kayma",
    advantageText4: "7/24 hizmet",
    advantageSubText4: "Sistemin düzgün çalışmasını sağlar, 7/24 müşteri hizmeti sunar",
    advantageText5: "Kullanımı kolay",
    advantageSubText5: "Çeşitli emir sistemleri ve işlem araçları, risk kontrol edilebilir",
    advantageText6: "Her zaman, her yerde · güvenli işlem",
    advantageSubText6: "BiKing platformu web, mobil uygulama, API ve FIX bağlantısı sunar",
    netWorkTitle: "26 ülke 1.2 milyon kullanıcının ortak seçimi",
    netWorkSubTitle: "Kullanıcılara daha güvenli ve istikrarlı kripto varlık türev işlem hizmeti sunmaya çalışıyoruz",
    smxz: "QR kodu ile indirin",
    fxbzj: "Risk teminat fonu",
    fkbz: "Her işlem için kapsamlı fon risk kontrol güvencesi",
    question1: "1. BiKing borsası tanıtımı",
    questionContent1: "BiKing borsası, ABD/Kanada MSB çifte lisansına sahip, Singapur merkezli küresel lider bir dijital varlık işlem platformudur.",
    question2: "2. BiKing borsası hangi ürünleri sunuyor?",
    questionContent2: "BiKing borsası şu ürünleri sunar: Süresiz kontratlar — derinlik avantajı, saniyede eşleştirme; Spot işlem — 0 komisyon, hızlı tamamlama; Kopya topluluğu — deneyimli traderlar, istikrarlı stratejiler; Hediye işlemi — özel model, sürekli avantajlar; Web cüzdanı — merkeziyetsiz tek duraklı hizmet",
    question3: "3. BiKing borsasına nasıl kaydolunur?",
    questionContent3: "BiKing borsasının resmi web sitesinde veya BiKing uygulamasında kaydolabilirsiniz.",
    question4: "4. BiKing borsası üzerinden dijital para nasıl satın alınır?",
    questionContent4: "BiKing borsası hızlı para satın alma, çoklu ödeme yöntemleri ve çoklu fiat para birimleri ile küresel kullanıcılara daha fazla seçenek sunar.",
    question5: "5. Dijital varlık işlemi nasıl yapılır?",
    questionContent5: "BiKing borsasında işlem yapmak istediğiniz dijital varlığı seçin, işlem sayfasına girin, al/sat seçin, işlem miktarı ve fiyatını girin, onaylayın.",
    question6: "6. BiKing borsası kullanıcı varlık güvenliğini nasıl sağlar?",
    questionContent6: "BiKing borsası çok katmanlı şifreleme teknolojisi ile kullanıcı bilgi ve varlık güvenliğini sağlar.",

    investor: "3M kripto para yatırımcısı güveni",
    transaction: "BiKing'de yatırım yapın, işlem yapın ve büyüyün",
    hypt: "Küresel güvenlik lideri dijital varlık kontrat işlem platformu",
    yjpc: "Tek tıkla aç/kapat",
    jscrj: "Anlık para yatırma/çekme, işleme 60 saniyede başlayın, gerçek sıfır kayma",
    zcpt: "Kayıt ve işlemle USDT kazanın",
    email: "E-posta adresi",
    phone: "Telefon numarası",
    zc: "Kayıt ol",
    yhjaqbz: "Banka seviyesi güvenlik",
    lhdmch: "0 kayma saniyede eşleştirme",
    qthkf: "7/24 müşteri hizmetleri",
    rmjmhb: "Popüler kripto paralar",
    jrsq: "BiKing topluluğuna katılın",
    hqzxhd: "En son BiKing etkinlik bilgilerini ve çevrimiçi desteği alın",
}
const navCard = {
    join: "BiKing'e Katılın",
    hzdl: "BiKing işbirliği ajan sözleşmesi katılımınızı bekliyor",
    jmrx: "Ajanlık başvuru hattı: 183283232998",
    contract: "Çevrimiçi kontrat",
    yxhy: "Hızlı kontrat BiKing çifte kontrat sürpriz lansman",
    jylh: "Daha esnek işlem, daha zengin kazanç",
    usa: "ABD VE KANADA MSB",
    zmjys: "Yurtdışı tanınmış borsa BiKing çoklu ülke uyum lisansı",
    fxpf: "Risk anında tazminat, güvenilir güvenlik",
    srhy: "BiKing kontrata ilk giriş %30 nakit hediye"
}

const choice = {
    gjyh: "26 ülke 1.2 milyon kullanıcının ortak seçimi",
    jyfu: "Kullanıcılara daha güvenli ve istikrarlı kripto varlık türev işlem hizmeti sunmaya çalışıyoruz",
    wsmxzwm: "Neden bizi seçmelisiniz",
    jsty: "Anında deneyim",
    jmsj: "İşlem arayüzü tasarımı platformun çok yıllık kullanıcı operasyon deneyimini birleştirir",
    kfx: "Riske dayanıklı fiyat mekanizması",
    pthybz: "Platform kontrat para birimi fiyatı çok kaynaklı endeks entegrasyon algoritması kullanır",
    zjaqbz: "Fon güvenlik garantisi",
    zjdt: "Tüm fon dinamikleri çoklu offline imzalarla tamamlanır",
    jszc: "Üst düzey teknoloji desteği",
    ptjstd: "Platform teknoloji ekibi birinci sınıf blockchain teknoloji uzmanlarından oluşur",
    jcjz: "Kademeli pozisyon azaltma mekanizması",
    hqbh: "Piyasa koşullarına göre kullanıcı işlem risk kontrol mekanizmasını tetikler",
    kf: "7/24 müşteri hizmeti",
    ptkf: "Platform 7/24 müşteri hizmeti vardiya sistemi kullanır"
}

const plat = {
    ptgn: "Platform fonksiyonları",
    zjms: "Hediye modeli",
    zjjs: "Hediye modeli, BiKing ekibinin tüm ağ kontrat kullanıcıları için ilk çıkardığı özel kontrat modelidir",
    zcms: "Tam hesap modeli",
    zcjs: "Tam hesap modelinde tüm pozisyonların teminatı ve kayan kar/zarar birbirine bağlıdır",
    zucms: "Ayrı hesap modeli",
    zucjs: "Ayrı hesap modelinde her emir birbirinden bağımsızdır",
    gdgn: "Kopyalama fonksiyonu",
    gdjs: "Kopyalama fonksiyonu başlatıldığında kopya traderın tüm açma/kapama işlemleri senkronize edilir",
    bfpc: "Kısmi kapanış",
    bfjs: "Belirli miktarda long veya short pozisyon bulundurulduğunda piyasa dalgalanmalarına göre kapanış tutarı seçilebilir",
    fxkc: "Ters pozisyon açma",
    fxjs: "Sistem piyasanın en iyi fiyatıyla mevcut pozisyonu kapatır ve ters yönde eşit miktarda pozisyon açar",
    zjbzj: "Teminat ekleme",
    zjbzjjs: "Belirli miktarda long veya short pozisyon bulundurulduğunda mevcut parametrelere göre teminat eklenebilir"
}

const risk = {
    fxbzj: "Risk teminat fonu",
    fxbz: "Her işlem için kapsamlı fon risk kontrol güvencesi"
}

const license = {
    license: "BiKing MSB finansal lisansı aldı",
    hgyy: "Uyumlu operasyon, küresel genişleme",
    login: "Giriş yap",
    download: "BiKing'i indirmek için tarayın",
    support: "Destek",
    jsjy: "Her zaman işlem, anlık tamamlama",
    ljxz: "Hemen BiKing Uygulamasını İndir"
}

const footer = {
    yhyh: "Kullanıcı dostu",
    jypt: "Kontrat işlem platformu",
    yhzc: "Kullanıcı desteği",
    flsm: "Ücret açıklaması",
    ggzx: "Duyuru merkezi",
    yhxz: "Kullanıcı gereksinimleri",
    tksm: "Şartlar açıklaması",
    fxzs: "Risk bildirimi",
    xylb: "Anlaşma listesi",
    gywm: "Hakkımızda",
    gy: "Hakkında",
    lxwm: "Bize ulaşın",
    appxz: "Uygulama indirme",
    callus: "BiKing Genesis'e abone olun",
    zwzxxx: "Son haberler, içgörüler ve fiyat dalgalanmalarını takip edin",
    zc: "Kayıt ol",
    email: "E-posta adresi",
    callingus: "Bize ulaşın",
    bqsy: "Tüm hakları saklıdır",
    tips: "Hatırlatma: Yatırım risklidir, piyasaya girerken dikkatli olun"
}

const card = {
    title: "Neden en kullanıcı dostu kontrat platformuyuz",
    text: "BiKing servet yaratmanıza, büyütmenize ve korumanıza yardımcı olur",
    djxn: "Komisyon iadesi",
    jsqd: "%100 komisyon anlık iadesi işlem maliyetini önemli ölçüde düşürür",
    zcbz: "Anlık para yatırma/çekme",
    cssbz: "Anlık para yatırma/çekme, fon güvenliği sağlarken hiçbir işlem fırsatı kaçmaz",
    gld: "Kullanımı kolay",
    zxhd: "Kayıt & pozisyon açma sadece 10 saniye sürer",
    qthfw: "7/24 hizmet",
    kffw: "Rahat etkileşim, altın teminat mekanizması, 7/24 destek",
    bjyy: "Kullanımı kolay",
    fxkk: "Çeşitli emir sistemleri ve işlem araçları, risk kontrol edilebilir",
    axjy: "Her zaman, her yerde · güvenli işlem",
    bkms: "BiKing platformu web, mobil uygulama, API ve FIX bağlantısı sunar"
}

const news = {
    title: "Haberler & Görünüm",
    text: "Dünyanın önde gelen kripto para borsasının haberlerini ve özelliklerini öğrenin",
    sy: "Görünüm",
    ltitle: "Bitcoin gelişmekte olan pazarların benzersiz zorluklarını çözebilir mi?",
    ldesc: "Bu makale ilk olarak Cointelegraph'ta göründü. Blockchain Economy İstanbul Zirvesi gelişmekte olan pazarlara odaklanırken...",
    more: "Daha fazla",
    xwfbs1: "Basın odası",
    rdesc1: "Dijital varlık borsası BiKing Blockchain Economy İstanbul Summit 2022'yi sponsor oldu",
    xwfbs2: "Basın odası",
    rdesc2: "Dijital varlık borsası BiKing Blockchain Economy İstanbul Summit 2022'yi sponsor oldu"
}

const info = {
    hzhb: "Otomatik işlem platformu iş ortakları",
    qsjy: "Trading botları ile BiKing'de kolayca işlem yapın",
    quadency: "QUADENCY",
    clpt: "Profesyonel otomatik işlem strateji platformu",
    stacked: "Stacked",
    glcf: "Kullanıcılar Stacked ile kripto endekslerine yatırım yapabilir"
}
const menu = {
    creditCardOrder: "Ödeme siparişi",
    ptmb: "C2C",
    kjmb: "Hızlı para satın al",
    xykmb: "Kredi kartıyla para satın al",
    order: "Sipariş",
    userOrder: "Kullanıcı siparişi",
    merchantOrder: "Satıcı siparişi",
    quickOrder: "Hızlı sipariş",
    merchant: "Satıcı",
    asMerchant: "Satıcı ol",
    advertisingManage: "Reklam yönetimi",
    financialStatements: "Mali tablolar",
    messageCenter: "Mesaj merkezi",
    more: "Daha fazla",
    paymentSettings: "Ödeme ayarları",
    publish: "Reklam yayınla",
    overview: "Genel bakış",
    aqzx: "Güvenlik merkezi",
    phsz: "Tercih ayarları",
    hykhj: "Kontrat festival sezonu yeni işlem çağı",
    xszn: "Yeni başlayan rehberi",
    bwyjy: "BiKing araştırma enstitüsü",
    bwsq: "BiKing topluluğu",
    yhxz: "Kullanıcı gereksinimleri",
    bwysp: "BiKing türev ürünleri",
    jyxz: "OTC işlem gereksinimleri"
}
const otc = {
    Realtimequotes:'Gerçek zamanlı kotasyonlar sadece referans içindir, lütfen nihai fiyat için üçüncü taraf servis sağlayıcının sayfasındaki fiyatı baz alın',
Realtimequotes1:'İşlem Başına Limit',
Realtimequotes2:'Referans Fiyatı',
Realtimequotes3:'Satın Al',
Realtimequotes5:'Lütfen satın alma tutarını girin',
Realtimequotes6:'Maksimum',
Realtimequotes7:'Maksimum limiti aşıyor',
Realtimequotes8:'Miktar',
Realtimequotes9:'İşlem Ücreti',
Realtimequotes10:'Ödeme Yöntemi',
Realtimequotes11:'Teslimat Süresi',
Realtimequotes12:'Ödeme başarılı olduktan sonra 10-20 dakika',
Realtimequotes13:'Satın Almayı Onayla',
Realtimequotes14:'Satın Alma Adımları',
Realtimequotes15:'Satın alınacak dijital para birimini, kullanılacak yasal para birimini ve servis sağlayıcıyı seçin',
Realtimequotes16:'Satın alma tutarını girin, üçüncü taraf servis sağlayıcının web sitesinde bilgileri doldurun ve ödemeyi tamamlayın',
Realtimequotes17:'Satın alınan dijital parayı BiKing varlık yükleme kayıtlarında, sipariş detaylarını ise servis sağlayıcının web sitesinde görüntüleyin',
Realtimequotes18:'Satın alma işlemi için {XXXXX} sitesine yönlendirileceksiniz',
Realtimequotes24:'Önemli Uyarı',
Realtimequotes19:'{XXXXX}, üçüncü bir tarafça bağımsız olarak işletilen, yasal para birimleri ile kripto para birimleri alışveriş platformudur. Tüm ilgili hizmetler {XXXXX} tarafından sağlanmaktadır;',
Realtimequotes20:'Referans fiyatı, platform işlem ücretini içeren fiyattır. Gerçek işlem fiyatı için {XXXXX} resmi web sitesindeki fiyat geçerlidir;',
Realtimequotes21:'BiKing, bu hizmetin kullanımından kaynaklanan herhangi bir kayıp veya zarardan sorumluluk kabul etmemektedir.',
Realtimequotes22:'Anladım, Hemen İlerle',
Realtimequotes23:'Satın Alma Tutarı',
Realtimequotes25:'Üçüncü Taraf İşlemi',
Realtimequotes26:'Lütfen öncelikle e-posta bilgilerinizi tamamlayın',
Realtimequotes27:'Şimdi Tamamla',
    bjgq: "Bu fiyat teklifinin süresi doldu, lütfen yeni teklif alın",
    gxbj: "Fiyatı güncelle",
    meBuy: 'satın almak istiyorum',
    服务商: 'hizmet sağlayıcı',
    zxkdh: "Minimum değişim {min} {symbol}",
    zdkdh: "Maksimum değişim {max} {symbol}",
    Available: "Kullanılabilir bakiye",
    Unknown: "Bilinmeyen",
    qxgz: "İptal kuralı: Alıcı günlük 200 iptal sınırına ulaşırsa satın alma fonksiyonu kısıtlanır.",
    xncs: "Sana satıyor",
    qxzzffs: "Lütfen ödeme yöntemi seçin",
    qdqx: "İptali onayla",
    wzxx: "Tekrar düşüneyim",
    msk: "Alıcı ödeme yöntemi",
    zhmc: "Hesap adı",
    zhxq: "Hesap detayları",
    xzhb: "Para birimi seç",

    buyer: "Alıcı",
    seller: "Satıcı",
    goSet: "Ekle",
    addPayWayTitle: "Ödeme yöntemi ekle",
    addPayWay: "Dijital para {type} için en az bir ödeme yöntemi eklemeniz veya etkinleştirmeniz gerekir",
    supportPayWay: "{type} destekli ödeme yöntemleri eklemeniz ve etkinleştirmeniz gerekir",
    top: "Sabitle",
    marginTips: "{baseMarginPaid} USDT teminat ödediniz, en az {needMargin} USDT daha ödemeniz gerekiyor",
    eyqx: "Günlük 3 şikayet iptali şikayet başlatmayı kısıtlar",
    qdbzgm: "Artık satın almayacağınıza emin misiniz?",
    qxbtk: "Sipariş iptal edildiğinde para iade edilmez",
    yzjbzj: "Normal satıcı ek teminat ödedi",
    xbjjcbzj: "Temel teminatın eklenmesi gerekiyor",
    jg: "Fiyat",
    zxjgxd: "Mevcut son fiyatla sipariş ver",
    je: "Tutar",

    ccxe: "Limiti aştı",
    yebz: "Yetersiz bakiye",
    qxsm: "Lütfen önce kimlik doğrulaması yapın",

    dfb: "Para bekleniyor",
    jywc: "İşlem tamamlandı",
    buy: "Satın al",
    sell: "Sat",
    coin: "Para birimi",
    allCoin: "Tüm para birimleri",
    frenchCurrency: "Fiat para",
    payWay: "Ödeme yöntemi",
    all: "Tümü",
    bankCard: "Banka kartı",
    zfb: "Alipay",
    wx: "WeChat",
    search: "Sorgula",
    merchant: "Satıcı (30 gün tamamlanan/30 gün tamamlama oranı)",
    turnover: "İşlem hacmi",
    completionRate: "% Tamamlama oranı",
    quotaOrNumber: "Miktar/Limit",
    number: "Miktar",
    quota: "Limit",
    price: "Birim fiyat",
    paymentMethod: "Ödeme yöntemi",
    trade: "İşlem",
    handlingFee: "0 komisyon",
    buyUsdt: "USDT satın al",
    sellBtc: "USDT sat",
    theRemainingAmount: "Kalan miktar",
    userRealName: "Kullanıcı gerçek adı",
    businessMessage: "Satıcı mesajı",
    wantPay: "Ödemek istiyorum",
    wantSell: "Satmak istiyorum",
    receive: "Alacağım",
    password: "Şifre",
    pleaseEnterPassword: "Lütfen şifreyi girin",
    cancel: "İptal",
    buyUSDT: "USDT Satın Al",
    sellUSDT: "USDT Sat",
    Paymentchannel: "Ödeme kanalı (Lütfen servis sağlayıcı döviz kuruyla aynı olmasına dikkat edin.)",
    lumpSum: "Toplam tutar",
    agree: "BiKing ile C2C işlemi yapmayı kabul ediyorsanız,",
    mzsm: "BiKing C2C İşlem Yasal Feragatnamesi'ni",
    quit: "Çıkış",
    confirm: "Onayla",
    orderDetail: "Sipariş detayı",
    limitExceeded: "Limiti aştı",
    quantityRemaining: "Kalan miktar yetersiz",

    cryptoTitle: "USDT satın almak birkaç basit adımda",
    cryptoSubTitle: "Küresel güvenlik lideri dijital varlık kontrat işlem platformu",
    availableBalance: "Kullanılabilir bakiye",
    sellAll: "Tümünü sat",
    fundsTransfer: "Fon transferi",
    threeStep: "Para satın alma sadece üç adım",
    advantage: "BiKing ile kripto para alım satım avantajları",
    commonQuestion: "Sıkça sorulan sorular",
    otc_title: "C2C ile sıfır komisyonlu kripto para al/sat",
    otc_title1: "BiKing'de güvenli ve kolay sıfır komisyonlu işlem. Hemen banka havalesi, kredi kartı ve diğer ödeme yöntemleriyle USDT işlemi yapın",
    commonQuestion1: "Kripto para C2C işlemi nedir?",
    commonQuestion2: "C2C işleminin maliyeti nedir?",
    commonQuestion3: "BiKing C2C'de satıcı nedir?",
    commonQuestion4: "BiKing C2C satıcıları kâr ediyor mu?",
    commonQuestion5: "C2C dolandırıcılığı nasıl önlenir?",
    commonQuestion1_desc: "Kripto C2C, merkezi borsa gibi aracı olmadan doğrudan kripto para takasıdır.",
    commonQuestion2_desc: "C2C işlem maliyeti platforma, kripto paraya ve ağ yoğunluğuna göre değişir.",
    commonQuestion3_desc: "BiKing C2C satıcıları, platformda reklam yayınlayan onaylı kullanıcılardır.",
    commonQuestion4_desc: "BiKing C2C satıcılarının kârlılığı çeşitli faktörlere bağlıdır.",
    commonQuestion5_desc: "C2C dolandırıcılığını önlemek için kimlik doğrulayın, güvenli platform kullanın.",
    register: "Kayıt ol",
    registerByPhone: "E-posta veya telefon numarasıyla kayıt",
    authentication: "Kimlik doğ",
    authenticationId: "Kimlik doğrulamasını tamamlamak için sadece kimlik belgesi gerekli",
    buyCoins: "Para satın al",
    buyCoinsByCard: "Kredi kartı/banka kartı veya banka havalesi ile para satın al",
    fast: "Hızlı ve kolay",
    easyUse: "Para satın alma işlemi basit",
    fastPayment: "Sadece birkaç dakika içinde hızlıca tamamlanır.",
    multiplePayment: "Çoklu ödeme yöntemleri",
    platformSupports: "Platform çoklu ödeme yöntemlerini destekler",
    flexibleConvenient: "Kullanıcılara daha fazla esneklik ve kolaylık sağlar.",
    safeReliable: "Güvenli ve güvenilir",
    measure: "Çoklu güvenlik teknolojileri ve önlemleri kullanılır",
    informationSecurity: "Fon güvenliği ve kullanıcı bilgi güvenliği sağlanır",
    questionTitle1: "1. BiKing borsası tanıtımı",
    questionSubTitle1: "BiKing borsası, ABD/Kanada MSB çifte lisansına sahip, Singapur merkezli küresel lider bir dijital varlık işlem platformudur",
    questionTitle2: "2. BiKing borsası hangi ürünleri sunuyor?",
    questionSubTitle2: "BiKing borsası şu ürünleri sunar: Süresiz kontratlar — derinlik avantajı, saniyede eşleştirme; Spot işlem — 0 komisyon, hızlı tamamlama; Kopya topluluğu — deneyimli traderlar, istikrarlı stratejiler; Hediye işlemi — özel model, sürekli avantajlar; Web cüzdanı — merkeziyetsiz tek duraklı hizmet",
    questionTitle3: "3. BiKing borsasına nasıl kaydolunur?",
    questionSubTitle3: "BiKing borsasının resmi web sitesinde veya BiKing uygulamasında kaydolabilirsiniz",
    questionTitle4: "4. BiKing borsası üzerinden dijital para nasıl satın alınır?",
    questionSubTitle4: "BiKing borsası hızlı para satın alma, çoklu ödeme yöntemleri ve çoklu fiat para birimleri ile küresel kullanıcılara daha fazla seçenek sunar",
    questionTitle5: "5. Dijital varlık işlemi nasıl yapılır?",
    questionSubTitle5: "BiKing borsasında işlem yapmak istediğiniz dijital varlığı seçin, işlem sayfasına girin, al/sat seçin, işlem miktarı ve fiyatını girin, onaylayın",
    questionTitle6: "6. BiKing borsası kullanıcı varlık güvenliğini nasıl sağlar?",
    questionSubTitle6: "BiKing borsası çok katmanlı şifreleme teknolojisi ile kullanıcı bilgi ve varlık güvenliğini sağlar",

    orderType: "Sipariş türü",
    orderStatus: "Sipariş durumu",
    to: "-",
    startTime: "Başlangıç tarihi",
    endTime: "Bitiş tarihi",
    orderNo: "Sipariş numarası",
    status: "Durum",
    totalPrice: "Toplam tutar",
    numberOrFee: "İşlem miktarı/komisyon",
    tradingPartners: "İşlem ortağı",
    time: "Zaman",
    operate: "İşlem",
    details: "Detay",
    noPay: "Ödeme bekleniyor",
    payed: "Ödendi",
    finish: "Tamamlandı",
    canceled: "İptal edildi",
    complaint: "İtiraz sürecinde",
    legalCurrency: "Fiat para tutarı",
    virtualCurrency: "Dijital para",
    virtualCurrencyAddress: "Alım adresi",
    paymenttype: "Ödeme türü",
    creatTime: "Oluşturulma zamanı",
    success: "Başarılı",
    pending: "İşlemde",
    awaiting: "Onay bekliyor",
    declined: "Başarısız",

    mjskfs: "Satıcı ödeme yöntemi",
    mjfkfs: "Alıcı ödeme yöntemi",
    toPay: "Ödemeye git",
    ddzdqx: "{payTime} içinde ödeme yöntemi seçmezseniz, sipariş otomatik iptal edilir",
    paying: "Karşı taraf ödeme yapıyor...",
    fkckh: "Ödeme referans numarası:",
    dfwfkqx: "Karşı taraf {payTime} içinde ödeme yapmazsa, sipariş otomatik iptal edilir",
    ddqxwfck: "Sipariş iptal edildi, ödeme bilgileri görüntülenemez",
    ddqxckh: "Sipariş iptal edildi, ödeme referans numarası:",
    ssz: "İtiraz sürecinde, lütfen bekleyin, ödeme referans numarası:",
    qxss: "İtirazı iptal et",
    xzfkfs: "Seçtiğiniz ödeme yöntemi",
    ddywc: "Sipariş tamamlandı",
    ss: "İtiraz",
    wcfqss: "* Sipariş tamamlandıktan 1 dakika sonra itiraz başlatılabilir",
    bnfqss: "* {time} saat sonra itiraz başlatılamaz",
    zxkf: "* OTC satın alımdan sonra T+1 gün beklemelisiniz",
    sjyjn: "Satıcı {deposit} {depositName} teminat ödedi",
    wen1: "1. Ne zaman ödeme alabilirim?",
    da1: "Karşı taraf ödemeyi tamamladığında bildirim alacaksınız",
    wen2: "2. Alıcı sipariş verdikten sonra ödeme yapmazsa ne olur?",
    da2: "Satıcı siparişi iptal edemez ama beklemek çok uzun sürerse itiraz edebilirsiniz",
    wen3: "3. Dijital varlıkları zamanında serbest bırakmazsam ne olur?",
    da3: "Ödeme alındığında zamanında onaylamazsanız itiraza neden olabilir",
    wen4: "4. Ödeme alırken dikkat edilmesi gerekenler",
    da4: "1) Ödemeyi gerçekten aldığınızdan emin olun<br/>2) Alıcının banka hesabı ile platform hesabı uyuşmuyorsa dikkatli olun",
    qzgdsjnzf: "Ödenecek, lütfen {payTime} içinde {associatedAdMerchantNickname} adlı satıcıya {totalAmounts} {fiatCurrency} ödeyin, ödeme referans numarası:",
    nxdfgm: "{associatedAdMerchantNickname} ({realName}) adlı satıcıdan {amount_s} {coinsName} satın aldınız",
    dfxngm: "{userNickName} ({realName}) adlı kullanıcı sizden {amount_s} {coinsName} satın aldı",
    nxdfcs: "{associatedAdMerchantNickname} ({realName}) adlı satıcıya {amount_s} {coinsName} sattınız",
    dfxncs: "{userNickName} ({realName}) adlı kullanıcı size {amount_s} {coinsName} sattı",
    payed: "Ödendi",
    dddffx: "Karşı tarafın serbest bırakması bekleniyor...",
    njhdq: "{quantity}{coinsName} alacaksınız",
    qxdd: "Siparişi iptal et",
    kfqss: "Ödemeden {complaintPayed} dakika sonra karşı taraf serbest bırakmazsa itiraz edebilirsiniz",
    yfkfkckh: "Karşı taraf ödeme yaptı, ödeme referans numarası:",
    qjkqrsk: "Lütfen ödemeyi en kısa sürede onaylayın",
    ddnsk: "Ödemenizi bekliyoruz",
    zfje: "Ödeme tutarı",
    skzh: "Alım hesabı:",
    fkzhxm: "Ödeme hesap adı:",
    qdskh: "* Kendi ödeme aracınızda parayı aldığınızdan emin olun",
    fbl: "Serbest bırak",
    dfyqrfk: "* Karşı taraf ödemeyi onayladı, {complaintPayed} dakika sonra itiraz edebilirsiniz",
    jkcssk: "* Karşı taraf ödemeyi onayladıktan 24 saat sonra itiraz edemezsiniz",
    qrfb: "Serbest bırakmayı onayla",
    qwbqr: "Ödemeyi aldığınızdan ve tutarın doğru olduğundan emin olun",
    wyqrskzq: "Ödemeyi aldığımı ve tutarın doğru olduğunu onaylıyorum",
    tjssyy: "Lütfen itiraz nedenini gönderin",
    srssyy: "Lütfen itiraz nedenini girin",
    sctpxt: "Resim yükle (isteğe bağlı)",
    upload: "Yükle",
    zdscsz: "* En fazla 3 resim, jpeg/jpg/png formatında, 3MB'tan küçük",
    sstj: "Gönder",

    qrfk: "Ödemeyi onayla",
    fkje: "Ödeme tutarı",
    sdzz: "* Platform otomatik kesinti desteklemez, lütfen manuel transfer yapın",
    bzts: "* BTC, USDT, BiKing gibi notlar eklemeyin",
    wfk: "Ödenmedi",
    w: "Ben",
    srxxfs: "Bilgi gir, Enter ile gönder",
    dan: "Tek",
    bnch: "Aynı tür ödeme yöntemi eklenemez",
    sd: "Anlık değişim",
    from: "Öde",
    to: "Al",
    rate: "Dönüşüm oranı",
    successful: "Değişim başarılı",
    fees: "Komisyon",
    slippage: "Kayma",
    standards: "Komisyon standartları",
    transactionamount: "İşlem tutarının {num}'si",
    confirm: "Değişimi onayla",
    records: "Tüm anlık değişim kayıtları",
    tocurrency: "Harcanan para birimi",
    consumption: "Harcanan miktar",
    Getcurrency: "Alınan para birimi",
    GetQuantity: "Alınan miktar",
    ExchangeStatus: "Değişim durumu",
    Exchangetime: "Değişim zamanı",
    Youwillconsume: "Harcayacaksınız",
    YouwillGET: "Alacaksınız",
    Updatequote: "Fiyatı güncelle",
    Failed: "Değişim başarısız",
    Consumption: "Harcama kanalı",
    Completed: "Tamamlandı",
    chaeckrecords: "Tüm anlık değişim kayıtlarını görüntüle》",
    Converted: "Başarıyla {aaa}'yı {bbb}'ye dönüştürdünüz",
    recommend: "Önerilen",
    wcsj: "Tamamlama Süresi"
}
const otcMerchant = {
    bzj: "Teminat",
    mmggs: "Alım satım reklam sayısı",
    bx: "Sınırsız",
    ggzed: "Reklam toplam kotası",
    kzjgged: "Eklenebilir reklam kotası",
    zjbzjbs: "Ek teminat çarpanı",
    tbzss: "Eş zamanlı 10 gösterim",

    tjsjsqb: "Satıcı başvuru formunu gönder",
    wcgjkycrz: "Gelişmiş KYC doğrulamasını tamamlayın",
    ynlx: "Form incelendikten sonra OTC temsilcisi sizinle iletişime geçecektir",

    zbzl: "Bilgi hazırlama",
    kssh: "Hızlı inceleme",

    h1: "Akıllı işlem",
    h2: "C2C işlem uzmanı olun",
    h3: "Onaylı satıcı olmak üzeresiniz",
    sjqy: "Satıcı ayrıcalıkları",
    c2cjy: "C2C işlemlerinde <span>0 komisyon</span> dışında, satıcılara daha birçok ayrıcalık sunuyoruz",
    fbq: "Fiat para bölgeniz",
    ptsj: "Normal satıcı",
    xsqy: "Onaylı satıcı olun, daha fazla ayrıcalıktan yararlanın",
    wtd: "Başvuru başarılı olursa sipariş verebilirsiniz",
    xjn: "{deposit} teminat gereklidir",
    ljsq: "Hemen başvur",
    cwptsj: "Normal satıcı oldunuz",
    cwrzsj: "Onaylı satıcı oldunuz",
    rzsj: "Onaylı satıcı",
    xrd: "Piyasada en yüksek güvenilirlik",
    nbyq: "Sadece BiKing iç davetiyle",
    rzbs: "Daha prestijli satıcı onay işareti",
    pmq: "Öncelikli sıralama hakkı",
    kffw: "1'e 1 müşteri hizmeti",
    sjxy: "OTC {level} sözleşmesi",
    xsjc: "Yeni başlayanlar kılavuzu",
    jygz: "İşlem kuralları",
    close: "Kapat",
    submited: "Gönderdim",
    submitSuccess: "Gönderim başarılı",

    sqsj: "Satıcı olmak için başvur",
    fwxy: "biking BiKing satıcı hizmet sözleşmesi",
    xyb: "BiKing, kullanıcıların dijital varlık alım satımı yapması ve ilgili hizmetleri sunması için özel olarak tasarlanmış bir platformdur.",
    ptsm: "Platform beyanı:",
    p1: "1. Bu web sitesi sadece dijital varlık alım satım bilgileri sağlamak, dijital varlık alım satımı için görüşme ve işlem yapma ortamı sunmak amacıyladır.",
    p2: "2. Bu web sitesindeki tüm görüşler, haberler, tartışmalar, analizler, fiyatlar, öneriler ve diğer bilgiler genel piyasa yorumlarıdır.",
    p3: "3. Bu web sitesinin içeriği önceden haber verilmeksizin değiştirilebilir.",
    p4: "4. İnternet tabanlı işlem sistemleri kullanmak da risk içerir.",
    p5: "5. Bu web sitesini kara para aklama, kaçakçılık, ticari rüşvet vb. yasa dışı faaliyetler için kullanmak yasaktır.",
    p6: "6. Bu web sitesini kötü niyetle piyasayı manipüle etmek, haksız işlemler vb. etik olmayan faaliyetler için kullanmak yasaktır.",
    p7: "BiKing hizmet sözleşmesini kabul ettiğinizde, platform beyanının tamamını kabul ettiğiniz varsayılır.",
    zcbzj: "Madde 1: Varlık teminatı",
    p8: "1. Satıcı platform KYC ve kara para aklama önleme incelemesini geçtikten sonra, platform satıcıdan platform hesabına belirli miktarda teminat yatırmasını isteyecektir.",
    p9: "2. Teminat miktarı, platformdaki satıcının fiat varlıklarında gösterilecek ve işlem sırasında kullanıcılara da gösterilecektir.",
    p10: "3. Aşağıdaki durumlarda platform, satıcının teminatına el koyma vb. işlemler yapma hakkına sahiptir.",
    p11: "1) Satıcı işlem sırasında anlaşmazlık yaşar ve sorumlu olduğu belirlenir ancak iş birliği yapmazsa;",
    p12: "2) Satıcı bu platformdaki onaylanmamış hesaplarla işlem yaparsa;",
    p13: "3) Satıcı bu platformu herhangi bir yasa dışı faaliyet için kullanırsa;",
    p14: "4) Satıcı bu sözleşmeyi veya platformdaki herhangi bir yasal belgeyi ihlal ederse;",
    p15: "5) Satıcı kullanıcıları başka platformlara yönlendirmeyi amaçlıyorsa;",
    p16: "6) Satıcı kullanıcıları sahte kayıt yapmaya teşvik edip platformun yeni kullanıcı promosyon ödüllerini almayı amaçlıyorsa;",
    p17: "7) Satıcı platform iş ortaklarının kullanıcılarını başka platformlara yönlendirmeye teşvik ediyorsa.",
    cxzg: "Madde 2: Satıcı statüsünün iptali",
    p18: "Aşağıdaki durumlarda platform satıcı statünüzü tek taraflı olarak feshetme hakkına sahiptir:",
    p19: "1. İşlemler sırasında platform kullanıcıları tarafından birden fazla kez şikayet edilirseniz;",
    p20: "2. Gönderilen başvuru materyallerinde herhangi bir sahte bilgi varsa;",
    p21: "3. İşlemlerde dolandırıcılık vb. güveni kötüye kullanma davranışları görülürse;",
    p22: "4. Platform müşteri hizmetleriyle sipariş işlemede iş birliği yapmaz veya kasıtlı olarak geciktirirseniz;",
    p23: "5. Platform kurallarını kötü niyetle kullanarak kazanç sağlamaya çalışırsanız;",
    p24: "6. Yasa, düzenleme, bu sözleşme veya platformun yasal belgeleri ihlal edilirse;",
    p25: "7. Platformun belirlediği kamu düzeni ve adil ticaret kurallarına uymayan davranışlar varsa;",
    p26: "8. Diğer yasa ve düzenleme ihlalleri.",
    zlbh: "Madde 3: Satıcı bilgilerinin korunması",
    p27: "1. Satıcı bilgilerinin yönetimi: Satıcı olmak için başvururken platforma sunduğunuz doğrulama bilgileri (önceki kimlik doğrulama materyalleri dahil), geri alınamaz şekilde platformda saklanmak üzere yetkilendirilir.",
    p28: "2. Platform bu bilgileri ulusal adli ve idari makamlara sunabilir;",
    p29: "3. Platform bu bilgileri bağlı şirketlerine sunabilir;",
    p30: "4. Üçüncü taraflar sizlere hizmet sunarken gerekli bilgileri paylaşabilir;",
    p31: "5. Üçüncü taraflarla olan uyuşmazlıkların çözümü için kimlik bilgileriniz paylaşılabilir.",
    sjcn: "Madde 4: Satıcı taahhütleri",
    p32: "1. Bu sözleşmenin tamamını kabul etmeniz doğrulama başvurusu için ön koşuldur.",
    p33: "2. Herhangi bir yasa dışı veya bu sözleşmeyle yasaklanmış amaçlar için başvurmadığınızı beyan ve taahhüt edersiniz.",
    p34: "3. Platform hizmetlerini başka web sitelerine veya hizmetlere zarar verecek şekilde kullanamazsınız.",
    p35: "4. Platformun izni olmadan herhangi bir bilgi veya veri elde etmeye çalışamazsınız.",
    p36: "5. Platformu kullanma amacınızın yasa ihlali olmadığını beyan edersiniz.",
    p37: "6. Satıcılar platformun bilgi açıklama gerekliliklerine uymayı kabul eder.",
    ptmz: "Madde 5: Platform muafiyeti",
    bcfx: "Aşağıdaki durumlarda platform sorumluluk kabul etmez:",
    p38: "1. Hesap şifrenizi başkalarına verir veya paylaşırsanız;",
    p39: "2. Hacker saldırıları, bilgisayar virüsleri, telekomünikasyon arızaları vb. nedenlerle;",
    p40: "3. Bağlantılı web sitelerinden (internet bankacılığı vb.) kaynaklanan bilgi sızıntıları;",
    p41: "4. Kullanıcıların yanlış veya eksik bilgi vermesi nedeniyle;",
    p42: "5. Platform dışı nedenlerle varlıklarınızın dolandırılması.",
    ptts: "Madde 6: Platform hatırlatmaları",
    p43: "1. Bu web sitesi üçüncü taraf bağlantıları içerebilir.",
    p44: "2. Bu platform sadece dijital varlık alım satımı için aracılık hizmeti sağlar.",
    p45: "3. Bu web sitesine giriş yaparak tüm sözleşme koşullarını kabul etmiş olursunuz.",
    p46: "4. 'Kabul Et' butonuna tıklayarak sözleşme koşullarını kabul etmiş sayılırsınız.",
    p47: "5. Platform bu sözleşmeyi bildirim yapmadan değiştirme hakkını saklı tutar.",
    tyxy: "Bu sözleşme içeriğini kabul ediyorum",
    nextStep: "Sonraki adım"
}
const user = {
    txxz: "Fon şifresini değiştirdikten sonra 24 saat içinde çekim yapılamaz",
    name: "Takma ad",
    rzdj: "Kimlik doğrulama seviyesi",
    phone: "Telefon",
    email: "E-posta",
    zzc: "Varlık değerlemesi",
    hours24: "24 saat",
    market: "Piyasa durumu",
    notice: "Duyuru",
    more: "Daha fazla>>",
    cb: "Para yatırma",
    tb: "Para çekme",
    hz: "Transfer",
    wsm: "Kimliği doğrulanmamış",
    cjrz: "Temel doğrulama",
    gjrz: "Gelişmiş doğrulama",
    qwgjrz: "Gelişmiş Doğrulamaya Git",
    aqszx: "Güvenlik ayarları tamamlandı",
    xgaqszx: "Güvenlik ayarlarınızı değiştirin",
    dlmm: "Giriş şifresi",
    zjdl: "Giriş şifresi ayarlayarak doğrudan hesabınızla giriş yapabilirsiniz",
    ghmm: "Şifreyi değiştir",
    sz: "Ayarla",
    jymm: "İşlem şifresi",
    yzjymm: "Hesap fonu hareketlerinde önce işlem şifresini doğrulamanız gerekir",
    ghjymm: "İşlem şifresini değiştir",
    sjyz: "Telefon doğrulaması",
    yzdx: "Giriş, para çekme, şifre değiştirme ve güvenlik ayarları için doğrulama SMS'i alın",
    xgsj: "Telefon numarasını değiştir",
    zwbd: "Henüz bağlanmadı",
    ggyz: "Google doğrulaması",
    syzn: "Kullanım kılavuzu",
    bd: "Bağla",
    yxyz: "E-posta doğrulaması",
    tbqr: "Para çekme onayı için kullanabileceğiniz bir e-posta bağlayın",
    bdyx: "E-posta bağla",
    xgyx: "E-postayı değiştir",
    xyx: "Yeni e-posta",
    dljl: "Son 10 giriş kaydı",
    zjdljl: "Bunlar son 10 giriş geçmişinizdir",
    dlsj: "Son giriş zamanı",
    ip: "IP adresi",
    aqsz: "Güvenlik ayarları",
    yhdl: "Kullanıcı girişi",
    xgbdsj: "Bağlı telefon numarasını değiştir",
    bdsj: "Telefon bağlama",
    dxyzm: "SMS doğrulama kodu",
    second: "saniye",
    fsyzm: "Doğrulama kodu gönder",
    xsjh: "Yeni telefon numarası",
    ggyzm: "Google doğrulama kodu",
    yxyzm: "E-posta doğrulama kodu",
    confirm: "Onayla",
    edit: "Düzenle",
    name: "Ad",
    srxm: "Lütfen adınızı girin",
    zjlx: "Kimlik belgesi türü",
    xzzjlx: "Lütfen kimlik belgesi türünü seçin",
    zjhm: "Kimlik numarası",
    srzjhm: "Lütfen kimlik numaranızı girin",
    zcsr: "Lütfen şifreyi tekrar girin",
    mmbyz: "Şifreler uyuşmuyor!",
    sfz: "Kimlik kartı",
    jgz: "Askerlik belgesi",
    hz: "Pasaport",
    jmtxz: "Tayvan ikamet izni",
    gatxz: "Hong Kong-Makao ikamet izni",
    hwid: "Yurt dışı kimlik",
    srdx: "Lütfen SMS doğrulama kodunu girin",
    sryx: "Lütfen e-posta doğrulama kodunu girin",
    srgg: "Lütfen Google doğrulama kodunu girin",
    jdlmm: "Eski giriş şifresi",
    xdlmm: "Yeni giriş şifresi",
    qrxmm: "Yeni şifreyi onayla",
    qrdlmm: "Giriş şifresini onayla",
    jjymm: "Eski işlem şifresi",
    xjymm: "Yeni işlem şifresi",
    qrjymm: "İşlem şifresini onayla",
    qwcyz: "Lütfen doğrulamayı tamamlayın",
    smrz: "Lütfen önce kimlik doğrulaması yapın",
    sryzm: "Lütfen doğrulama kodunu girin",
    srsjh: "Lütfen telefon numaranızı girin",
    xgdlmm: "Giriş şifresini değiştir",
    szdlmm: "Giriş şifresi ayarla",
    xgjymm: "İşlem şifresini değiştir",
    szjymm: "İşlem şifresi ayarla",
    czmm: "Şifreyi sıfırla",

    bdgg: "Google Authenticator'ı bağla",
    lbyzq: "Lütfen Google Authenticator'ı indirin",
    smewm: "Google Authenticator ile QR kodu tarayın",
    srdm: "QR kodu tanınmazsa lütfen kodu elle girin",
    copy: "Kopyala",
    copySuccess: "Kopyalama başarılı",
    sryx: "Lütfen e-posta adresinizi girin",
    srzqyx: "Lütfen geçerli bir e-posta adresi girin",
    srsjyzm: "Lütfen SMS doğrulama kodunu girin",
    sryxyzm: "Lütfen e-posta doğrulama kodunu girin",
    srggyzm: "Lütfen Google doğrulama kodunu girin",
    passwordTypeError: "Şifre formatı hatalı: 8-32 karakter, büyük/küçük harf ve rakam içermeli",
    passwordDiff: "Şifreler uyuşmuyor",
    zcsrxmm: "Lütfen şifreyi tekrar girin",
    language: "Dil",
    bdhb: "Yerel para birimi",
    wdbph: "Stablecoin tercihi",

    "相关问题": "İlgili sorular",
    "为什要进行身份认证": "Neden kimlik doğrulaması yapmalıyım?",
    "上传中": "Yükleniyor...",
    "开始上传": "Yüklemeye başla",
    "录制第一段视频": "İlk video klibi kaydet",
    "录制第二段视频": "İkinci video klibi kaydet",
    "录制完成": "Kayıt tamamlandı",
    "请手持身份证正面": "Lütfen kimliğinizin ön yüzünü elinizde tutun",
    "正对摄像头": "Kameraya doğru bakın",
    "摘下眼镜": "Gözlük ve şapkayı çıkarın",
    "请按视频文字提示录制视频": "Lütfen video talimatlarını izleyerek kayıt yapın",
    "开始录制": "Kayda başla",
    "第一段视频": "Birinci video",
    "第二段视频": "İkinci video",
    "录制一段视频": "Video kaydet",
    "点击开始录制": "Kayda başlamak için tıklayın",
    "视频录像认证": "Video kimlik doğrulaması",
    "身份证号": "Kimlik numarası",
    证件验证: "Kimlik Belgesi Doğrulaması (Fotoğraf/Tarama)",
    zjyz: "Kimlik Belgesi Doğrulaması",
    "请确保图片格式为": "Lütfen jpeg/jpg/png formatında ve 2MB'tan küçük olduğundan emin olun",
    "请手持证件照": "Lütfen kimlik ve günlük imzanızı elinizde tutun",
    "当日签名照": "Kimlik + günlük imza fotoğrafı",
    "上传证件签名页": "İmza sayfasını yükle",
    "请保证所有信息清晰": "Tüm bilgilerin okunaklı olduğundan emin olun",
    "上传证件页信息": "Kimlik sayfası bilgilerini yükle",
    "请选择国家": "Lütfen ülke seçin",
    "请上传正面证件照": "Lütfen kimliğin ön yüzünü yükleyin",
    "请上传反面证件照": "Lütfen kimliğin arka yüzünü yükleyin",
    "手持证件照": "Kimlik el fotoğrafı",
    "请选择区域": "Lütfen bölge seçin",
    "认证要求": "Doğrulama gereksinimleri",
    "证件信息": "Kimlik bilgileri",
    "人脸识别": "Yüz tanıma",
    "立即认证": "Hemen doğrula",
    "认证要求": "Doğrulama gereksinimleri",
    "什么是加密货币P2P交易": "Kripto para P2P işlemi nedir?",
    "最好的P2P加密货币交易所是什么": "En iyi P2P kripto para borsası hangisidir?",
    "P2P交易的成本有多少": "P2P işlem maliyeti nedir?",
    "什么是BikingP2P上的商家": "BiKing P2P'de satıcı nedir?",
    "我们正在审核您的申请": "Başvurunuzu inceliyoruz",
    "预计审核时间": "Tahmini inceleme süresi: 72 saat",
    "驳回": "Reddedildi",
    "未提交": "Gönderilmedi",
    "手续费等级": "Komisyon seviyesi",
    "去认证": "Doğrulamaya git",
    "已认证": "Doğrulandı",
    "开通更多权限": "Kimlik doğrulayarak daha fazla yetki aç",
    "在别人贪婪时要保持警惕": "Başkaları açgözlüyken temkinli olun, temkinliyken açgözlü olun - Buffett",
    "kyc声明": "Ben {Name}, kimlik numaram {No}. BiKing'de gönüllü olarak kayıt olup işlem yapıyorum.",
    "编辑头像": "Profil fotoğrafını düzenle",
    "请选择一个头像用作您个人资料的照片": "Lütfen profil fotoğrafınız için bir resim seçin",
    "中国": "Çin",
    "其他": "Diğer",
    "questionTitle1": "1. Neden kimlik doğrulaması yapmalıyım?",
    "questionSubTitle1": "BiKing küresel uyumlu kimlik doğrulama hizmeti kullanır",
    "questionTitle2": "2. Kimlik doğrulaması yapmanın faydaları nelerdir?",
    "questionSubTitle2": "OTC özelliklerine erişmek için tüm kullanıcılar kimlik doğrulaması yapmalıdır",
    "questionTitle3": "3. Kimlik doğrulaması nasıl güncellenir?",
    "questionSubTitle3": "Kimlik bilgileriniz değiştiğinde, çevrimiçi destekle iletişime geçebilirsiniz",
    "questionTitle4": "4. KYC doğrulaması ne kadar sürer?",
    "questionSubTitle4": "Bilgileriniz genellikle 5 dakika içinde incelenir",
    "questionTitle5": "5. BiKing kimlik doğrulaması güvenli midir?",
    "questionSubTitle5": "BiKing kimlik doğrulaması güvenlidir",
    "questionTitles": "1. Kimlik süresi dolduysa;",
    "questionTitles1": "2. Kimlikteki ad değiştiyse;",
    "questionTitles2": "3. Kimlik numarası değiştiyse;",
    "questionTitles3": "4. Vatandaşlık değiştiyse;",
    "questionTitles4": "5. Fiat para kullanımı için kimlik güncellemesi gerekiyorsa;",
    "questionTitles5": "6. Sistem diline uygun ad değişikliği (ID'den pasaporta);",
    "Z1001": "Sistem hatası",
    "Z1003": "Doğrulama kesildi",
    "Z2002": "Ağ hatası",
    "Z2003": "İstemci cihaz zaman hatası",
    "Z2006": "Doğrulama başarısız",
    "Z5050": "Yüz doğrulama başarılı",
    "Z5051": "Yüz fotoğrafı yükleme başarısız",
    "Z5052": "Veri hatası veya istisna",
    "Z5053": "Ağ hat",
    "Z5054": "Kamera izni yok veya veri alınamadı",
    "Z5055": "Kullanıcı çıkış yaptı",
    "Z5056": "Çok fazla deneme",
    "Z5057": "Video yükleme zaman aşımı",
    "Z5058": "Video formatı desteklenmiyor",
    "Z5059": "Videoda tanınabilir yüz yok",
    "Z5128": "Doğrulama başarısız: aynı kişi değil",
    "法币充值": "Fiat para yatırma & çekme limitleri",
    "无限额": "Limitsiz",
    "数字货币充值": "Kripto para yatırma",
    "数字货币提现限额": "Kripto para çekme limitleri",
    "C2C交易限额": "C2C işlem limitleri",
    "参数不合法": "Geçersiz parametre",
    "h5smrz": "Kimlik Doğrulama",
    "bhzhan": "Hesap güvenliği için şifre ayarla",
    "jxsmrz": "Kullanıcı fon güvenliği için kimlik doğrulaması yapın",
    qwrz: "Doğrulamaya Git",
    dgzhzd: "1. Tek bir hesap, günde en fazla 5 kez gönderilebilir.",
    rhzp: "2. Gönderdiğiniz fotoğraflar, videolar veya belge ayrıntıları hiçbir şekilde depolanmayacak veya kullanılmayacaktır.",
    sfzm: "Kimlik Kanıtı",
    zjqfg: "Belge Düzenleyen Ülke",
    dw: "Konumlandırma",
    sfxx: "Kimlik Bilgisi",
    dqdw: "Mevcut Konum",
    gjdq: "Ülke/Bölge"
}

const h5 = {
    chart: "Grafik",
    mmp: "Alım-satım paneli",
    sscj: "Gerçek zamanlı işlemler",
    wt: "Emir",
    lswt: "Geçmiş emirler",
    zj: "Fon",
    sj: "Piyasa fiyatı",
    ky: "Kullanılabilir",
    zczh: "Varlık eşdeğeri",
    dj: "Dondurulmuş",
    zwsj: "Henüz veri yok",
    zx: "Favoriler",
    buysell: "Al/Sat"
}

const worldCup = {
  common: {
    cancel: 'İptal etmek',
    confirm: 'onaylamak',
    iKnow: 'Anlıyorum',
    businessClosed: 'Hizmet kapatıldı',
    points: 'integral',
    day: 'gökyüzü',
    hour: 'Saat',
    minute: 'nokta',
    second: 'Saniye',
    noMatch: 'Henüz maç yok',
  },
  index: {
    liveFeed: 'gerçek zamanlı dinamikler',
    heroTitle: 'Dünya Kupası\'na bahis',
    heroSplit: 'oymak',
    heroPrizePool: 'Ödül havuzu',
    heroMillionPrizePool: '1 milyonluk ödül havuzunu paylaş',
    heroSub: 'Ayrıca Tesla ve Dünya Kupası biletleri de sizleri bekliyor.',
    heroJoinedPrefix: 'Çoktan',
    heroJoinedSuffix: 'İnsanlar katılıyor ve ödül havuzu büyümeye devam ediyor.',
    activityTimeLabel: 'Etkinlik süresi:',
    refreshing: 'Yenileniyor...',
    releaseToRefresh: 'Hemen yenilemek için bırakın',
    pullToRefresh: 'Yenilemek için aşağı çekin',
    livePrizePool: 'Gerçek zamanlı ödül havuzu',
    growing: 'Gerçek zamanlı olarak büyüyor',
    userPoolRatioLabel: 'Bireysel kullanıcılar ödül havuzunu paylaşabilir:',
    teamPoolRatioLabel: 'Takımlar ödül havuzunu paylaşabilir:',
    poolCountdownLabel: '{phase}. aşama ödül havuzu paylaşımına geri sayım',
    poolCountdownFinalLabel: 'Son aşama ödül havuzu paylaşımına geri sayım',
    poolActivityStartCountdownLabel: 'Etkinlik başlangıcına kalan',
    poolSplitDoneBadge: 'Ödül havuzu paylaşımı tamamlandı',
    totalAllocatedPoolLabel: 'Toplam paylaşılan havuz',
    poolAllocateFirst: '1. paylaşım',
    poolAllocateSecond: '2. paylaşım',
    poolAllocateThird: '3. paylaşım',
    poolAllocateFinal: 'Final paylaşımı',
    poolTeamPrefix: 'Takım: ',
    poolPersonalPrefix: 'Bireysel: ',
    poolPersonalCount: 'Bireysel: {n} kişi',
    teamTitle: 'Bir ekip kurun ve gelirinizi ikiye katlayın',
    teamSubPrefix: 'Ekibe katılın ve gelişme fırsatı yakalayın',
    teamSubSuffix: 'gelir',
    teamAgentTitle: 'Temsilci ekibi',
    teamAgentDesc: 'Platform temsilcileri tek tıklamayla bir takım oluşturabilir ve <span class="wc-hl"> takım üyesi puanları, toplam takım puanları </span> olarak toplanacaktır. Aynı zamanda, ekip görevlerini tamamlayarak <span class="wc-hl"> ek ekip puanı </span> kazanabilirsiniz. Takımın puanı ne kadar yüksek olursa, <span class="wc-hl"> ödül havuzunu </span> paylaşma şansı da o kadar artar.',
    createTeamNow: 'Şimdi bir takım oluştur',
    applyAgentNow: 'Ben temsilci değilim, hemen başvur',
    teamUserTitle: 'özgürlük ekibi',
    teamUserDesc: 'Temsilci olmanıza gerek yok, ücretsiz bir takıma katılabilir, diğer ücretsiz kullanıcılarla takım oluşturabilir, <span class="wc-hl2"> takım puanlarına</span> katılabilir ve <span class="wc-hl2"> ödül havuzu paylaşımı</span> fırsatlarına sahip olabilirsiniz.',
    joinNow: 'Şimdi katıl',
    championTitle: 'Şampiyona Tahmini',
    championSub: 'Her kullanıcı yalnızca bir kez tahmin yapabilir ve kilitlendikten sonra değiştirilemez. Tahminin doğru olması durumunda ödül havuzunu bireysel olarak paylaşma hakkına sahip olacaksın.',
    championHintPrefix: 'Kazananı doğru tahmin eden kullanıcılar bir ödül havuzuna sahip olacak',
    championHintSuffix: 'oyma için nitelikler',
    championWin: 'Kazananı tahmin ettiğiniz için tebrikler',
    championLose: 'Üzgünüm, doğru tahmin edemediniz',
    championWinSub: 'bireysel ödül havuzunu paylaşma hakkı kazandınız.',
    championNoParticipation: 'Etkinlik sona erdi, tahmine katılmadınız',
    confirmPredict: 'Tahmini onayla',
    predictCountdown: 'Tahmin Geri Sayımı',
    predictEnded: 'Tahmin sona erdi',
    notice1: 'Kullanıcı p***12 bahsi tamamladı ve 500 puan kazandı',
    notice2: 'Kullanıcı k***88 az önce bir Tesla kullandı',
    notice3: 'Kullanıcı a***23 bahsi tamamladı ve 1200 puan kazandı',
    notice4: 'Kullanıcı x***56, 100 puan almak için arkadaşlarını davet etti',
    notice5: 'Kullanıcı m***07 az önce 1 Dünya Kupası bileti kullandı',
    tabPredict: 'Bahis',
    tabTask: 'Görev',
    tabRank: 'sıralama',
    tabExchange: 'değişme',
    tabMine: 'bana ait',
    tabRules: 'kural',
  },
  toast: {
    refreshSuccess: 'Yenileme başarılı',
    predictSuccess: 'Bahis başarılı, sonuçlar gönderildi',
    inviteJumping: 'Davet sayfasına git...',
    applyAgentPending: 'Temsilci uygulama işlevi geliştirilme aşamasındadır, bu yüzden bizi izlemeye devam edin!',
    championLocked: 'Şampiyonluk tahmini kilitlendi!',
    exchangeSubmitted: 'Ödeme başvurusu başarıyla gönderildi ve platformun müşteri hizmetleri ödül dağıtımı için sizinle iletişime geçecek.',
    pointsNotEnough: 'Puan yetersiz',
    createTeamSubmitted: 'Ekip başarıyla oluşturuldu',
    joinedFreeTeam: 'Özgürlük Ekibine katıldı',
  },
  section: {
    predictTitle: 'Maç bahisleri',
    predictSub: 'Oyunun sonucunu tahmin edin, doğru tahminler için +{correctPoints} puan, yanlış tahminler için +{wrongPoints} puan',
    predictRules: 'Bahis talimatları',
    taskTitle: 'Puan kazanmak için görevleri tamamlayın',
    taskSub: 'Çoklu görevler, çoklu ödüller, hızlandırılmış kar birikimi',
    exchangeTitle: 'Puan kullanma merkezi',
    exchangeSub: 'Zengin ödüller, ilk gelen alır',
    exchangeRules: 'Ödeme talimatları',
    rankTitle: 'Gerçek zamanlı skor tablosu',
    rankSub: 'Güçle yarışın ve en üst noktaya ulaşın',
    rulesTitle: 'Etkinlik kuralları',
    rulesSub: 'Şeffaf, açık, adil ve adil',
  },
  dialog: {
    taskTitle: 'Misyon bildirimi',
    taskReward: 'Tamamlandığında kullanılabilir',
    predictConfirmTitle: 'Maç bahisleri',
    predictConfirmHint: 'Sizce hangi takım kazanır?',
    predictPay: 'ödemek',
    predictPayTip: 'Varlık hesabından kesinti yapın, lütfen bakiyenin yeterli olduğundan emin olun.',
    predictConfirmBtn: 'Bahsi onayla',
    predictSuccessTitle: 'Bahis başarılı oldu',
    predictSuccessDesc: 'Bahis sonuçları başarıyla gönderildi ve kayıtlar "Bahislerim" bölümünde görüntülenebilir.',
    exchangeTitle: 'Ürün değişimi',
    exchangeNeedPoints: 'Gerekli puanlar',
    exchangeBalance: 'Denge:',
    exchangeContactTitle: 'En az bir iletişim bilgisini girin',
    exchangeTipTitle: 'Nazik ipuçları',
    exchangeTip1: 'Lütfen en az bir iletişim bilgisini girin. Başvurunun ardından platformun müşteri hizmetleri, ödül dağıtımı hakkında iletişim kurmak için sizinle iletişime geçecektir.',
    exchangeTip2: 'Uzun süre sizinle iletişime geçilmediyse lütfen işlem için müşteri hizmetlerine başvurun.',
    exchangeConfirm: 'Değişimi onayla',
    teamJoinTitle: 'Takıma katıl',
    teamCreateDesc: 'Ekip kuracağınızdan emin misiniz?',
    teamJoinFreeDesc: 'Özgürlük Takımına katılacağınızdan emin misiniz?',
    teamJoinTipTitle: 'Nazik ipuçları',
    teamJoinTipDesc: 'Temsilci ekibinin bir üyesisiniz ve ücretsiz bir ekibe katılamazsınız. Davet edenlerinizi (temsilcilerinizi) takım savaşlarına katılmak üzere bir takım oluşturmaya davet edebilirsiniz.',
    applyAgentContactTitle: 'Önemli duyuru',
    applyAgentContactPrefix: "Lütfen Telegram'da ekleyin: ",
    applyAgentContactSuffix: ' Temsilci başvurusu yapın. Temsilci olduktan sonra takım oluşturabilirsiniz.',
    applyAgentContactBtn: 'Anladım',
  },
  rank: {
    teamRank: 'Takım sıralaması',
    personRank: 'Kişisel sıralama',
    yourTeamRank: 'Takımınızın sıralaması',
    yourPersonRank: 'kişisel sıralamanız',
    captain: 'takım lideri:',
    currentPoints: 'Mevcut noktalar',
    members: 'üye',
    teamDetail: 'Takım detayı',
    noRankYet: 'Henüz sıralama yok',
  },
  mine: {
    myPoints: 'puanlarım',
    totalPoints: 'toplam puan',
    myPredict: 'Bahsim',
    myExchange: 'Benim değişimlerim',
    myBonus: 'Bonusuım',
    totalBonus: 'Aldığım toplam bonus',
    bonusPhase: 'Paylaşım aşaması：',
    bonusPhaseFirst: '1. aşama',
    bonusPhaseSecond: '2. aşama',
    bonusPhaseThird: '3. aşama',
    bonusPhaseFinal: 'Final aşaması',
    bonusTypeTeam: 'Takım havuzu',
    bonusTypePersonal: 'Bireysel havuz',
    bonusPoints: 'Paylaşım anındaki puan：',
    bonusType: 'Tür：',
    bonusAmount: 'Bonus：',
    totalCount: 'Toplam {total}',
    myTeam: 'benim takımım',
    selectTeam: 'Bir takım seçin',
    predictMatch: 'Maç',
    winTeam: 'kazanan takım',
    predictResult: 'Bahis sonuçları',
    hit: 'Doğru tahmin edildi',
    miss: 'Tahmin edilmedi',
    draw: 'Beraberlik',
    exchangeItem: 'Değişim öğeleri',
    contactInfo: 'İletişim bilgileri',
    exchangeStatus: 'Ödeme durumu',
    currentRank: 'Mevcut sıralama',
    notJoinedTeam: 'Takıma katılmadı',
    memberContribution: 'Üye katkıları',
    teamTaskContribution: 'Ekip görevi katkısı',
    loading: 'yükleniyor...',
    statusDone: 'Tamamlanmış',
    statusPending: 'İşleme',
    statusFail: 'Tekliften yararlanma başarısız oldu',
    logCompleteKyc: 'KYC\'yi tamamlayın',
    logExchangePrize: 'Ödülün kullanımı',
    logMatchPredict: 'Maç bahisleri',
    logDailySign: 'Günlük giriş',
    logFinishTask: 'Görevi tamamla',
    taskFirstRecharge: 'İlk para yatırma işlemini tamamlayın >= {amount} USDT',
    pagerTotal: 'Toplam {total} öğe',
    prevPage: 'Önceki sayfa',
    nextPage: 'Sonraki sayfa',
    goTo: 'Git',
    page: 'Sayfa',
  },
  mobile: {
    title: 'Dünya Kupası Bahisleri',
  },
  nav: {
    entry: 'Dünya Kupası Bahisleri',
  },
  mock: {
    korea: 'Güney Kore',
    germany: 'Almanya',
    china: 'Çin',
    uk: 'İngiltere',
    france: 'Fransa',
    portugal: 'Portekiz',
    senegal: 'Senegal',
    brazil: 'Brezilya',
    india: 'Hindistan',
    turkiye: 'Türkiye',
    usa: 'Amerika',
    jerseyPack: 'Resmi forma seti',
    vipCard: 'VIP şifreli üyelik kartı',
    jerseyKeyword: 'Jersey',
  },
  predict: {
    round: {
      group: 'grup aşaması',
      r32: '32. Tur',
      r16: '16. Tur',
      quarter: 'çeyrek final',
      semi: 'yarı finallar',
      third: 'üçüncülük maçı',
      final: 'finaller',
    },
    status: {
      joined: 'Zaten katıldım',
      open: 'Açık',
      ongoing: 'Oyun sırasında',
      ended: 'sona erdi',
    },
    btn: {
      joined: 'Zaten bahis',
      open: '{betPaymentAmount}USDT Şimdi bahis yapın',
      ongoing: 'Oyun devam ediyor',
      ended: 'Bahis sona erdi',
    },
    joinedMatchPhase: {
      pending: 'Başlamadı',
      ongoing: 'Devam ediyor',
      ended: 'Bitti',
    },
    joinedResult: {
      hit: 'Doğru +{points}',
      missPrefix: 'Yanlış',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: 'Fon kaynağı',
    poolSplit: 'Ödül havuzu paylaşımı',
    teamIntro: 'Takım Açıklaması',
    poolRulesTitle: 'Ödül havuzu açıklaması',
    teamRulesTitle: 'Takım Açıklaması',
    predictRulesTitle: 'Bahis talimatları',
    exchangeRulesTitle: 'Ödeme talimatları',
  },
  rulesText: {
    poolDesc1: 'Etkinliğin ilk bonusu {10万} USDT\'dir. Etkinliğin geçerlilik süresi boyunca işletme bonusunun bir kısmı, toplam ödül havuzunun sürekli artmasıyla orantılı olarak ödül havuzuna yatırılacaktır.',
    poolLine1: 'Her yükleme miktarının {5%} kadarı otomatik olarak ödül havuzuna girer;',
    poolLine2: '{contractFeePercentageToPool}% sürekli vadeli işlem ücreti otomatik olarak ödül havuzuna eklenir;',
    poolLine3: 'Geçerli bir kullanıcı her davet edildiğinde ödül havuzu otomatik olarak {10} USDT artacaktır.',
    poolLine4: '*0.01 USDT\'nin altındaki tutarlar ödül havuzuna dahil edilmez.',
    teamPoolTitle: 'Takım paylaşımı ödül havuzu',
    teamPoolRuleTitle: 'Takım paylaşımı ödül havuzu kuralları',
    teamPoolRule1: 'Takım ödül havuzuna bir kez kazanıldıktan sonra lider (özgürlük ekibi hariç) kazanılan paylaşım ödülünün %20\'sini alır. Lider ödülü = toplam ödül havuzu * paylaşım oranı * %20',
    teamPoolRule2: 'Kazanılabilir ödül havuzu paylaşımına katılabilen takım üyeleri, kişisel puan katkıları ağırlıklı olarak ödül paylaşımı alır. Takım üyesi ödülü = [(toplam ödül havuzu * takım paylaşım oranı) * (1 - %20) / kazanılabilir ödül havuzu paylaşımına katılabilen takım üyesi kişisel puanlarının toplamı] * kişisel toplam puanlar',
    userPoolTitle: 'Bireysel kullanıcıların ödül havuzunu paylaşmasına ilişkin kurallar',
    poolSplit1: 'İlk 8 takım belirlendikten sonra puan sıralamasında birinci olan takım ödül havuzunun %20\'sini paylaşacak ve bakiye birikmeye devam edecek.',
    poolSplit2: 'İlk 4 takım belirlendikten sonra puan sıralamasında birinci olan takım ödül havuzunun %30\'unu paylaşacak ve bakiye birikmeye devam edecek.',
    poolSplit3: 'Yarı finallerin ardından puan sıralamasında birinci olan takım ödül havuzunun %50\'sini paylaşacak ve bakiye birikmeye devam edecek.',
    poolSplit4: 'Finalden sonra puan sıralamasında birinci olan takım toplam ödül havuzunun {percentage}% kısmını paylaşacaktır. Paylaşım tamamlandıktan sonra takım üyelerinin kullanılabilir puanları sıfırlanır.',
    userPoolLine1: 'Oyunun sonunda şampiyonluğu doğru tahmin eden kullanıcı, ödül havuzunu bireysel olarak paylaşmaya hak kazanacaktır.',
    userPoolLine2: 'Şampiyonu doğru tahmin eden tüm kullanıcılar, toplam kişisel puanlarına göre ödül havuzunun {percentage}% kısmını paylaşacaktır. Paylaşım tamamlandıktan sonra kişisel kullanılabilir puanlar sıfırlanır.',
    poolFormula: '*Örnek: Bir takımda ödül paylaşımına hak kazanan N kullanıcı olsun, kullanıcı puanları N1, N2, N3...Nn olarak ifade edilsin, paylaşım anındaki toplam ödül havuzu A, bu turdaki paylaşım oranı %20 ve kaptan ödül oranı %20 ise, takım üyesi ödülü = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*kişisel toplam puan',
    teamRule1: '1. Yalnızca birinci düzey temsilciler ekip oluşumunu başlatabilir. Temsilci değilseniz temsilci olmak için başvuruda bulunabilir ve ekip oluşturabilirsiniz.',
    teamRule2: '2. Acenta değilseniz ve acente niteliklerini alamıyorsanız platformun belirlediği ücretsiz ekibe (acente olmayan kullanıcılar) katılabilirsiniz.',
    teamRule3: '3. Bir temsilci bir ekip oluşturduktan sonra kendisi ve ekip üyeleri otomatik olarak bir ekip haline gelecektir.',
    teamRule4: '4.Toplam ekip puanı = toplam ekip üyesi puanı + ekip görevi ödül puanı',
    teamRule5: '5. Ekip üyelerinin ödül havuzunu paylaşmasına yönelik yeterlilik gereksinimleri: etkinlik sırasında ≥ {quizTimesThreshold} kez tahmine katılın + sürekli vadeli işlem hacmi ≥ {poolContractThreshold}U',
    predictRule1: '1. Bahisler müsabaka başladıktan sonra kapatılacaktır.',
    predictRule2: '2. Her kullanıcı oyun başına yalnızca bir kez tahmine katılabilir.',
    predictRule3: '3. Bahis için 1 USDT ödemeniz gerekmektedir.',
    predictRule4: '4. Kazanan takımı doğru tahmin edin +10 puan, yanlış tahmin edin +1 puan',
    predictRule5: '5. Maçın (grup aşaması) "beraberlik" olması halinde, puanlar yanlış tahmine göre hesaplanacaktır, +1 puan',
    exchangeRule1: '1. Ödüllerin sayısı sınırlıdır ve stoklar bitene kadar kullanılacaktır; ilk gelen ilk alır.',
    exchangeRule2: '2. Ödül kullanıldıktan sonra ilgili puanlar düşülecek ve takımınızın puanları da buna göre düşülecektir.',
    exchangeRule3: '3. Ödülleri alırken iletişim bilgilerinizi girin; platform personeli daha sonraki ödül dağıtımıyla ilgili konularda sizinle iletişime geçecektir.',
    exchangeRule4: '4. Ödül kullanımı sırasında doldurulan iletişim bilgilerinin hatalı olması, ödül kullanımının engellenmesine neden olabilir. Lütfen onaylayıp dikkatlice kontrol edin ve haberleri takip etmeye devam edin.',
    exchangeRule5: '5. Platformdan uzun süre iletişim alamazsanız lütfen işlem için platformun müşteri hizmetleriyle iletişime geçin.',
    timeTitle: 'Etkinlik süresi',
    activePeriodLabel: 'Etkinlik geçerli zamanı:',
    activePeriodValue: '18 Mayıs 0:00 ~ 19 Temmuz 23:59:23',
    activeTip: 'Puanlar yalnızca etkinlik başladıktan sonra hesaplanır ve sayılır ve ödül havuzu birikmeye başlar.',
    predictPeriodLabel: 'Bahis zamanı:',
    predictPeriodValue: 'Şampiyon Bahisleri: 16 Temmuz 04:30:00 ~ 20 Temmuz 03:00:00',
    businessTitle: 'iş kuralları',
    businessRule1: '1. Geçerli davet kullanıcıları: Geçerli davet, davetlinin yüklemesinin ≥{inviteRechargeThreshold}U ve sürekli vadeli işlem hacminin ≥{contractVolumeThreshold}U olduğu anlamına gelir.',
    businessRule2: '2. Ekip üyelerinin ödül havuzunu paylaşması için gerekli yeterlilikler: Etkinlik sırasında ≥ {quizTimesThreshold} kez tahminde bulunun + sürekli vadeli işlem hacmi ≥ {poolContractThreshold}U',
    businessRule3: '3. Kişisel puanlar istediğiniz zaman hediye olarak kullanılabilir. Kullanıldıktan sonra ilgili kişisel ve takım puanları düşülecektir.',
    businessRule4: '4. Fiziksel ödüllerin sayısı sınırlıdır ve stoklar bitene kadar kullanılmalıdır.',
    businessRule5: '5. Dünya Kupası biletlerinin son kullanım tarihi, Dünya Kupası\'nın açılışından önceki gündür. Mücbir sebep nedeniyle fiziksel biletler kullanılamıyorsa eşdeğer USDT\'ye çevrilebilir.',
    statementTitle: 'ciddi beyan',
    statement1: '1. Her kullanıcı etkinliklere katılmak için yalnızca bir hesap kullanabilir. Etkinliklere katılmak için birden fazla hesabın (toplu kayıt hesapları, ilişkili hesaplar vb. dahil ancak bunlarla sınırlı olmamak üzere) kullanılması kesinlikle yasaktır. Sistem, katılımcı hesapların oturum açma cihazlarını ve IP adreslerini izleyecektir. Birden fazla hesabın aynı cihazı veya aynı IP adresini kullanarak çalıştığı tespit edilirse platform bunu ilgili hesap olarak belirleme hakkına sahiptir;',
    statement2: '2. Etkinliğe katılan kullanıcıların ticari davranışları doğru ve geçerli olmalıdır ve her türlü karşı ticaret, karşı ticaret veya kendi çıkarına işlem kesinlikle yasaktır.',
    statement3: '3. Platform, aşağıdakiler dahil ancak bunlarla sınırlı olmamak üzere risk kontrol sistemi aracılığıyla anormal ticaret davranışlarını tespit edecektir: pozisyonların yüksek frekanslı ters açılıp kapanması, aynı fiyattan korunma işlemleri ve düşük riskli arbitraj yıkama davranışı.',
    statement4: '4. Anormal ticari davranış tespit edildiğinde platform şunları yapma hakkına sahiptir: işlemin bu bölümünde oluşturulan puanları temizleme, kullanıcının faaliyetlere katılma hakkını iptal etme, ilgili ödülleri dondurma veya geri çekme',
    statement5: '5. Ödül havuzunun miktarı ve ödül dağıtımı platformun nihai istatistik sonuçlarına bağlı olacaktır. Platform, bu etkinliğin kurallarının nihai yorumunu yapma hakkını saklı tutar.',
  },
  exchange: {
    needPoints: 'Gerekli puanlar',
    stock: 'kalan stok',
    buyNow: 'Şimdi kullan',
    soldOut: 'Hepsi satıldı',
    badgeUnique: 'Sitedeki tek büyük ödül',
    badgeOnly3: 'Sadece 3 porsiyon',
    badgeOnly8: '🔥Sadece 8 adet',
    itemFinalTicket: 'Dünya Kupası Finali Biletleri',
    itemSignedFootball: 'imzalı futbol',
  },
  task: {
    earnPoints: 'Puan kazanın',
    goFinish: 'tamamlamak',
    goTeamTask: 'Takım puanı için görev yap',
  },
  taskGroup: {
    daily: 'günlük görevler',
    invite: 'Görevleri davet et',
    recharge: 'Görevleri yeniden şarj edin',
    teamTrade: 'Ekip ticaret görevleri',
    dailyLimitPrefix: 'Günlük ödül limiti',
    teamLimitPrefix: 'Takım günlük ödül limiti',
    dailyLimitNum: '50 puan',
    inviteLimitNum: '100 puan',
    teamLimitNum: '300 puan',
    limitSuffix: ', her gün saat 00:00:00\'da (GMT+08:00) yenilenir',
    rechargeLimitSuffix: 'Standardı karşılayıp karşılamadığını görmek için etkinlik süresi boyunca yalnızca ilk şarj hesaplanacaktır.',
    inviteCta: 'Şimdi davet edin ve puan kazanın',
    taskPredictOnce: 'Bir etkinlik bahisine her katıldığınızda',
    taskTrade10000: 'Tamamlanan her kümülatif sürekli vadeli işlem hacmi {tradeVolume}U\'dur',
    taskInviteValidUser: 'Geçerli bir kullanıcı daveti her tamamlandığında',
    taskInviteRegister: 'Arkadaşlarınızı kaydolmaya davet edin',
    taskInviteKyc: 'Arkadaşlarınızı KYC\'yi tamamlamaya davet edin',
    taskInviteRecharge: 'Arkadaşlarınızı ilk şarjı tamamlamaya davet edin',
    taskFirstRecharge: 'İlk para yatırma >= {amount} USDT',
    taskTeamTrade10000: 'Tamamlanan her kümülatif {tradeVolume} USDT sürekli vadeli işlem hacmi için ekip +{teamBonusPoints} puan alacaktır.',
  },
};
export {
    games,
    h5,
    trading,
    download,
    login,
    user,
    advertise,
    otcMerchant,
    otc,
    menu,
    time,
    state,
    text,
    seckillRes,
    header,
    hyy,
    index,
    indexPage,
    Verification,
    NAVS,
    FOOTERS,
    SIDEBAR,
    seckill,
    apply,
    recommend,
    market,
    banner,
    card,
    news,
    info,
    navCard,
    choice,
    plat,
    risk,
    license,
    footer,
    merchandiser,
    codeInfo,
    placeOrder,
    tableList,
    codelist,
    contractHyy,
    common,
    dialog,
    panKou,
    invite,
    property,
    contest,
    taskCenter,
    ieo,
    earn,
    tradingContest,
    agent,
    live,
    hongbao,
    worldCup
};



// WEBPACK FOOTER //
// ./src/i18n/lang/public/tr.js